import { TGetDocumentByPageParams } from '@/services';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '..';
import {
	IPayloadGetDefineDocumentAreaListSuccess,
	TDefineDocumentAreaDetailStore,
	TPayloadDeleteDocumentsRequest,
	TPayloadDownloadDocumentRequest,
	TPayloadGetDefineDocumentAreaListRequest,
	TPayloadUpdateDocumentItemRequest,
	TPayloadUploadDocumentRequest,
} from './define-document-area.type';

const initialState = {
	fetching: false,
	defineDocumentAreaList: [] as TDefineDocumentAreaDetailStore[],
	page: 1,
	total: 0,
	params: {} as TGetDocumentByPageParams,
};

const defineDocumentAreaSlice = createSlice({
	initialState,
	name: 'defineDocumentArea',
	reducers: {
		/**---- GET DEFINE_DOCUMENT_AREA LIST START ---- */
		getDefineDocumentAreaListRequest: (
			state,
			action: PayloadAction<TPayloadGetDefineDocumentAreaListRequest>
		) => {
			const { callback: _, ...params } = action.payload;

			state.fetching = true;
			state.params = params;
		},
		getDefineDocumentAreaListSuccess: (
			state,
			action: PayloadAction<IPayloadGetDefineDocumentAreaListSuccess>
		) => {
			const { defineDocumentAreaList, page, total } = action.payload;
			state.fetching = false;
			state.defineDocumentAreaList = defineDocumentAreaList;
			state.page = page;
			state.total = total;
		},
		getDefineDocumentAreaListFailure: (state) => {
			state.fetching = false;
		},
		/**---- GET DEFINE_DOCUMENT_AREA LIST END ---- */

		/**---- UPDATE DOCUMENT ITEM START ---- */
		updateDocumentItemRequest: (
			state,
			action: PayloadAction<TPayloadUpdateDocumentItemRequest>
		) => {
			state.fetching = true;
		},
		updateDocumentItemSuccess: (state) => {
			state.fetching = false;
		},
		updateDocumentItemFailure: (state) => {
			state.fetching = false;
		},
		/**---- UPDATE  DEFINE ITEM END ---- */

		/**---- DELETE DOCUMENT START ---- */
		deleteDocumentsRequest: (
			state,
			action: PayloadAction<TPayloadDeleteDocumentsRequest>
		) => {
			state.fetching = true;
		},
		deleteDocumentsSuccess: (state) => {
			state.fetching = false;
		},
		deleteDocumentsFailure: (state) => {
			state.fetching = false;
		},
		/**---- DELETE DOCUMENT END ---- */

		/**---- DOWNLOAD DOCUMENT START ---- */

		downloadDocumentsRequest: (
			state,
			action: PayloadAction<TPayloadDownloadDocumentRequest>
		) => {
			state.fetching = true;
		},

		downloadDocumentsSuccess: (state) => {
			state.fetching = false;
		},

		downloadDocumentsFailure: (state) => {
			state.fetching = false;
		},
		/**---- DOWNLOAD DOCUMENT END ---- */

		/**---- UPLOAD DOCUMENT START ---- */
		uploadDocumentsRequest: (
			state,
			action: PayloadAction<TPayloadUploadDocumentRequest>
		) => {
			state.fetching = true;
		},

		uploadDocumentsSuccess: (state) => {
			state.fetching = false;
		},

		uploadDocumentsFailure: (state) => {
			state.fetching = false;
		},
		/**---- UPLOAD DOCUMENT END ---- */
	},
});

export const DefineDocumentAreaSelectors = {
	selectFetching: (state: RootState) => state.defineDocumentArea.fetching,
	selectPage: (state: RootState) => state.defineDocumentArea.page,
	selectTotal: (state: RootState) => state.defineDocumentArea.total,
	selectDefineDocumentAreaList: (state: RootState) =>
		state.defineDocumentArea.defineDocumentAreaList,
	selectParams: (state: RootState) => state.defineDocumentArea.params,
};

export const DefineDocumentAreaActions = defineDocumentAreaSlice.actions;
export const DefineDocumentAreaReducer = defineDocumentAreaSlice.reducer;
